<template>
	<div>
		<vxe-modal v-model="modal_model" title="流水明细" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			streamdata: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				modal: true,
				loading: false,
				modal_width:1000,
				modal_height:500
			}
		},
		methods:{
			list_beforeCreateGrid(gridOptions){
				gridOptions.showFooter = true		
				gridOptions.toolbarConfig.buttons = []						
				// gridOptions.toolbarConfig.buttons = [{
				// 	name: '导出',
				// 	status: 'success',
				// 	code: 'export'
				// }]
				gridOptions.columns = [{
						field: 'type',
						title: '类型',
						width:50,
						slots : {
							default: ({row}) => {	
								let str= []
								if(row.type==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.type==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								return str
							}
						}
					},
					{
						field: 'wlncustomname',
						title: '客户名称'
					},
					{
						field: 'bankname',
						title: '结算账户',
					},
					{
						field: 'amount',
						title: '金额',
					},
					{
						field: 'transTime',
						title: '时间',
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue,true)
						}
					},
					{
						field: 'export_wln',
						title: '万里牛',
						slots : {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.streamdata
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		}
	}
</script>